export default {
  colors: [
    '#a30046',
    '#0046a3',
    '#51ae32',
    '#f39200',
    '#941e81',
    '#009fe3',
    '#8db097',
    '#d63515',
    '#006996',
    '#8e87c3',
    '#286638',
    '#d159c9',
    '#074e66',
    '#fb9792',
    '#2c2f2b',
    '#2a1b90',
    '#049e33',
    '#b75818',
    '#2d172b',
  ],
  compValues: [
    'Control',
    'Flowline',
    'Flying Lead',
    'Jumper',
    'Pipeline',
    'Riser',
    'Riser Base',
    'Subsea Processing',
    'Subsea Production',
    'Tree',
    'Umbilical',
  ],
  props: {
    colors: {
      type: Array,
      default: function() {
        return d3.schemePaired; //this.$options.colors;
      },
    },
    dimensionField: {
      type: String,
      required: true,
    },
    aggField: {
      type: String,
      required: true,
    },
    margins: {
      type: Object,
      default: () => {
        return { top: 25, right: 140, bottom: 20, left: 50 };
      }
    },
    title: {
      type: String,
      default: '',
    },
    labelFn: {
      type: Function,
      default: d => {
        return d.key;
      },
    },
    titleFn: {
      type: Function,
      default: d => {
        return d.value;
      },
    },
  },
  computed: {
    dateRangeString() {
      let [min, max] = this.dateRange;
      return `${min} - ${max}`;
    },
    dateRange() {
      return [Math.min.apply(null, this.$attrs.years), Math.max.apply(null, this.$attrs.years)];
    },
  },
  data() {
    return { chart: null };
  },
  methods: {
    reset() {
      this.chart.filterAll();
      dc.redrawAll();
    },
  },
};
